import React from 'react';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import API from 'fw/system/API';
import * as FormManager from 'fw/forms/form/FormManager'
import * as Notifications from 'fw/globals/Notifications';
import { TextBox, Form } from 'fw/forms';
import { Button, Label, ActionButton } from 'fw/components';
import * as APIModules from 'modules/app/API';
import * as App from 'modules/app/App';
import * as Modals from 'fw/globals/Modals';

class SponsorTypeInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState(props) {
        return {
			adding: props.newSponsorType,
			disabled: true,
            form: { 
				description: '',
				sponsorTypeCode: props.sponsorTypeCode,
			}
        };
    }

    handleCancel = () => {
        FormManager.checkUnsavedChanges(() => {
            if (this.props.onCancel)
                this.props.onCancel();
        })
    }

	componentDidMount() {
        this.loadSponsorType(this.props.sponsorTypeCode);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.sponsorTypeCode !== this.props.sponsorTypeCode || nextProps.newSponsorType !== this.props.newSponsorType)
            this.loadSponsorType(nextProps.sponsorTypeCode);
    }

    loadSponsorType = (sponsorTypeCode) => {
        if (this.state.adding) {
            this.setState({
				adding: true,
                disableSave: false,
				disabled: !App.hasPrivilege("AdminSponsorTypeSetupAdd"),
                form: { 
					description: '',
					sponsorTypeCode: sponsorTypeCode
				}
            });
            return;
        }

        var rq = {
            sponsorTypeCode: sponsorTypeCode
        };

        new API().get(APIModules.App.url('/sponsorTypeSetup/getSponsorTypeInfo'), rq,
            {
                success: (r) => {
                    // Store search results
                    this.setState({
                        adding: false,
						disabled: !App.hasPrivilege("AdminSponsorTypeSetupEdit"),
                        form: r.data
                    });
                }
            });
    }

    handleSave = () => {
        if (this.state.isValidated && !this._form.validate())
            return false;

        // Proceed
        var url = APIModules.App.url('/sponsorTypeSetup/saveSponsorTypeInfo');
		var form = this.state.form;

        let rq = {
			sponsorTypeCode: form.sponsorTypeCode,
            description: form.description,
			isNew: this.state.adding
        };

        this.setState({
            saving: true
        }, function () {
            new API().post(url, rq, {
                success: (r) => {
                    Notifications.success(r.message);

                    this.setState({
                        dirty: false,
                        form: {
                            ...this.state.form,
                            ...r.data,
                            original: {
                                ...this.state.form,
                                ...r.data
                            }
                        }
                    }, this.props.onUpdate());
                    FormManager.reset();
                },
                error: r => {
                    Notifications.error(r.error.errorMessage);
                }
            })
        });
    }

    handleChange = (form, callback) => {
        this.setState({ form }, callback);
    }

    handleDelete = () => {
        const me = this;

        var rq = {
            sponsorTypeCode: me.state.form.sponsorTypeCode
        };

        Modals.confirm(
            "If you wish to remove this Sponsor Type, please select 'Yes'. <br /><br />" +
            "Otherwise select 'No', and you will be returned to the previous screen.",
            function () {
                new API().post(APIModules.App.url('/sponsorTypeSetup/deleteSponsorType'), rq,
                    {
                        success: (r) => {
                            Notifications.success(r.message);
                            FormManager.reset();
                            me.props.onUpdate()
                        },
                        error: (r) => {
                            Notifications.error(r.error.errorMessage);
                        }
                    });
            });
    }

    renderActions() {
        return (
            <div className="pull-right">
                {App.hasPrivilege("AdminSponsorTypeSetupEdit") && !this.state.adding &&
                    <ActionButton id="btRemoveSponsorType" onClick={this.handleDelete} icon="trash">Remove Sponsor Type</ActionButton>
                }
            </div>
        )
    }

    render() {
        return (
            <React.Fragment>
                <ContentHeader title={this.state.adding ? "New Sponsor Type" : this.state.form.description}>
                </ContentHeader>
                <ContentBody>
                    <Row>
                        <Col md={12}>
                            <hr style={{ height: "1px", background: "#333" }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <Form
                                onChange={this.handleChange}
                                values={this.state.form}
                                unsavedChangesWarning={true}
                                ref={(form) => { this._form = form }}>
                                <Row>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label required>Sponsor Type Code</Label>
                                            <TextBox
                                                name="sponsorTypeCode"
                                                placeholder="Sponsor Type Code"
                                                maxLength={4}
                                                required
												disabled={this.state.disabled && !this.state.adding} />
                                        </FormGroup>
                                    </Col>
									<Col md={5}>
										<FormGroup>
                                            <Label>Description</Label>
                                            <TextBox
                                                name="description"
                                                placeholder="Description"
                                                maxLength={50}
												disabled={this.state.disabled} />
                                        </FormGroup>
									</Col>
                                </Row>
                            </Form>
                        </Col>
                        <Col md={2}>
                            {this.renderActions && this.renderActions()}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="pull-right">
                                <Button id="btnCancel" bsStyle="link" onClick={() => this.handleCancel()}>Cancel</Button>
                                <Button id="btnSave" onClick={this.handleSave} bsStyle="primary" disabled={this.state.disableSave}>Save</Button>
                            </div>
                        </Col>
                    </Row>
                </ContentBody>
            </React.Fragment>
        )
    }
}

export default SponsorTypeInfo;


// WEBPACK FOOTER //
// ./src/areas/admin/sponsorTypeSetup/SponsorTypeInfo.js